import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';


export interface IDeleteOrphanedManagedKeychainParams {
  id?: string;
}

export class DeleteOrphanedManagedKeychainRequest extends Request<IDeleteOrphanedManagedKeychainParams, IResult> {
    constructor(params: IDeleteOrphanedManagedKeychainParams) {
      super('deleteOrphanedManagedKeychainsForSite', params);
    }
}